"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
export default function ThePracticeDrQayyum() {
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: lineRef,
    isVisible: lineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: signatureRef,
    isVisible: signatureVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="4057" id="the-practice-dr-qayyum" className="relative overflow-hidden bg-primary py-24 md:py-32 lg:py-48" style={{
    color: "var(--secondary)"
  }}>
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)' opacity='0.8'/></svg>\")"
    }} />

      {}
      <div ref={lineRef} aria-hidden="true" className="pointer-events-none absolute right-6 top-0 hidden h-full w-px md:right-10 lg:right-16 lg:block">
        <div className="w-px origin-top transition-transform duration-[1800ms] ease-out" style={{
        backgroundColor: "hsl(43 89% 55%)",
        height: "100%",
        transform: lineVisible ? "scaleY(1)" : "scaleY(0)"
      }} />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-10">
          {}
          <div className="lg:col-span-4">
            <div ref={eyebrowRef} className="transition-all duration-1000 ease-out" style={{
            opacity: eyebrowVisible ? 1 : 0,
            transform: eyebrowVisible ? "translateY(0)" : "translateY(20px)"
          }}>
              <p className="font-mono text-xs uppercase tracking-[0.15em] sm:text-sm" style={{
              color: "hsl(174 25% 55%)"
            }}>
                — Our Approach
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-8">
            <div ref={quoteRef} className="transition-all duration-1000 ease-out" style={{
            opacity: quoteVisible ? 1 : 0,
            transform: quoteVisible ? "translateY(0)" : "translateY(30px)",
            transitionDelay: quoteVisible ? "150ms" : "0ms"
          }}>
              <blockquote className="font-serif font-light leading-[1.15] tracking-tight !text-4xl" style={{
              color: "var(--secondary)"
            }}>
                At Chaudhry Pulmonary Associates, patients receive careful evaluation, clear communication, and ongoing pulmonary and sleep medicine care for breathing and sleep-related concerns.
              </blockquote>

              <p className="mt-8 opacity-80" style={{
              color: "var(--secondary)"
            }}>
                Our goal is to help adults better understand their symptoms, treatment options, and next steps in care.
              </p>

              {}
              <div ref={signatureRef} className="mt-12 flex items-center gap-4 transition-all duration-1000 ease-out !h-[40px] md:mt-16" style={{
              opacity: signatureVisible ? 1 : 0,
              transform: signatureVisible ? "translateY(0)" : "translateY(15px)",
              transitionDelay: signatureVisible ? "400ms" : "0ms"
            }}>
                <SafeHydrate><Avatar className="size-12 rounded-lg" style={{
                  filter: "grayscale(1) contrast(1.2)"
                }}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/logo_mark.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/logo_mark.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692402/img/logo_mark.png-wvc-sizes" alt="Chaudhry Pulmonary Associates Logo" loading="lazy" decoding="async" src="https://strong-hare.10web.cloud/wp-content/uploads/2026/06/Logo.png" src="https://strong-hare.10web.cloud/wp-content/uploads/2026/06/CPA_header_horizontal_logo.png" src="https://strong-hare.10web.cloud/wp-content/uploads/2026/06/Logo.png" />
                  <AvatarFallback className="rounded-lg font-mono text-xs" style={{
                    backgroundColor: "var(--accent)",
                    color: "var(--primary)"
                  }}>
                    AQ
                  </AvatarFallback>
                </Avatar></SafeHydrate>

                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}